import type { MessageTranslator } from '@oneflowab/pomes';
import { EID_SIGNING_METHOD, EID_STAND_ALONE_ITEM_SIGNING_METHOD_KEY } from './constants';

export const getEidStandAloneList = (message: MessageTranslator) => {
  const ADES_TOOLTIP_MESSAGE = message({
    id: 'Advanced e-signature with verified identity and strong legal assurance.',
    comment: 'Description for an advanced electronic signature',
  });
  const eidStandAloneItems = [
    {
      key: 'seBankid',
      title: message({
        id: 'Swedish BankID',
        comment: 'Title for an electronic ID',
      }),
      isEnabled: true,
      isVisible: true,
      countries: [
        'SE',
      ],
      signingMethods: [
        {
          key: EID_STAND_ALONE_ITEM_SIGNING_METHOD_KEY.SE_BANKID,
          label: EID_SIGNING_METHOD.AdES,
          description: ADES_TOOLTIP_MESSAGE,
        },
      ],
    },
    {
      key: 'noBankid',
      title: message({
        id: 'Norwegian BankID',
        comment: 'Title for an electronic ID',
      }),
      isEnabled: true,
      isVisible: true,
      countries: [
        'NO',
      ],
      signingMethods: [
        {
          key: EID_STAND_ALONE_ITEM_SIGNING_METHOD_KEY.NO_BANKID,
          label: EID_SIGNING_METHOD.AdES,
          description: ADES_TOOLTIP_MESSAGE,
        },
      ],
    },
    {
      key: 'dkNemid',
      title: 'MitID',
      isEnabled: true,
      isVisible: true,
      countries: [
        'DK',
      ],
      signingMethods: [
        {
          key: EID_STAND_ALONE_ITEM_SIGNING_METHOD_KEY.DK_NEMID,
          label: EID_SIGNING_METHOD.AdES,
          description: ADES_TOOLTIP_MESSAGE,
        },
      ],
    },
    {
      key: 'fiFtn',
      title: 'Finnish Trust Network',
      isEnabled: true,
      isVisible: true,
      countries: [
        'FI',
      ],
      signingMethods: [
        {
          key: EID_STAND_ALONE_ITEM_SIGNING_METHOD_KEY.FI_FTN,
          label: EID_SIGNING_METHOD.AdES,
          description: ADES_TOOLTIP_MESSAGE,
        },
      ],
    },
  ];
  return eidStandAloneItems;
};
